import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        p: 3,
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        404 - Página No Encontrada
      </Typography>
      <Typography variant="body1" gutterBottom>
        La página que estás buscando no existe.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate("/")}
        sx={{ mt: 2 }}
      >
        Volver al inicio
      </Button>
    </Box>
  );
}

export default NotFound;
